import {
  mdiAirplane,
  mdiBeach,
  mdiBikeFast,
  mdiBookOpenPageVariant,
  mdiBusMultiple,
  mdiCarabiner,
  mdiDivingScuba,
  mdiDivingSnorkel,
  mdiFoodApple,
  mdiGuitarElectric,
  mdiHandshake,
  mdiHeartPlus,
  mdiHeartPulse,
  mdiHiking,
  mdiHumanFemaleDance,
  mdiHumanHandsdown,
  mdiLungs,
  mdiMeditation,
  mdiPalette,
  mdiRacquetball,
  mdiSilverwareForkKnife,
  mdiSki,
  mdiSpa,
  mdiWeight,
  mdiYoga,
} from "@mdi/js";
import type React from "react";

/** Material Design Icons by Pictogrammers, Apache 2.0. */
const paths = {
  longevity: mdiHeartPulse,
  networking: mdiHandshake,
  wellness: mdiSpa,
  painting: mdiPalette,
  dining: mdiSilverwareForkKnife,
  "group-trips": mdiBusMultiple,
  travel: mdiAirplane,
  skiing: mdiSki,
  gigs: mdiGuitarElectric,
  salsa: mdiHumanFemaleDance,
  kettlebell: mdiWeight,
  pranayama: mdiLungs,
  "yoga-philosophy": mdiBookOpenPageVariant,
  spinning: mdiBikeFast,
  recovery: mdiHeartPlus,
  "day-retreats": mdiBeach,
  pickleball: mdiRacquetball,
  "hot-yoga": mdiMeditation,
  nutrition: mdiFoodApple,
  "scuba-diving": mdiDivingScuba,
  snorkeling: mdiDivingSnorkel,
  "animal-flow": mdiHumanHandsdown,
  bouldering: mdiCarabiner,
  stretching: mdiYoga,
  trekking: mdiHiking,
} as const;

type FlatIconName = keyof typeof paths;

function FlatActivityIcon({
  name,
  ...props
}: Omit<React.SVGProps<SVGSVGElement>, "name"> & { name: FlatIconName }) {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...restProps}
    >
      <title>{name.replaceAll("-", " ")}</title>
      <path d={paths[name]} fill={color} />
    </svg>
  );
}

export const LongevityIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="longevity" />
);
export const NetworkingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="networking" />
);
export const WellnessIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="wellness" />
);
export const PaintingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="painting" />
);
export const DiningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="dining" />
);
export const GroupTripsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="group-trips" />
);
export const TravelIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="travel" />
);
export const SkiingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="skiing" />
);
export const GigsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="gigs" />
);
export const SalsaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="salsa" />
);
export const KettlebellIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="kettlebell" />
);
export const PranayamaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="pranayama" />
);
export const YogaPhilosophyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="yoga-philosophy" />
);
export const SpinningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="spinning" />
);
export const RecoveryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="recovery" />
);
export const DayRetreatsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="day-retreats" />
);
export const PickleballIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="pickleball" />
);
export const FlatHotYogaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="hot-yoga" />
);
export const FlatNutritionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="nutrition" />
);
export const FlatScubaDivingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="scuba-diving" />
);
export const FlatSnorkelingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="snorkeling" />
);
export const FlatAnimalFlowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="animal-flow" />
);
export const FlatBoulderingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="bouldering" />
);
export const FlatStretchingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="stretching" />
);
export const FlatTrekkingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <FlatActivityIcon {...props} name="trekking" />
);
